/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Link} from "react-router-dom";
import React from "react";

export const OptionalLink = (props) => {
    const { to, children } = props;
    if (to) {
        return <Link to={to}>{children}</Link>;
    } else {
        return children;
    }
}
